import { DomainModel } from 'domains/models';
import {
  WpAuthorItem,
  WpCategoryItem,
  WpTagItem,
} from 'integrations/wordpress/domains';

interface Props {
  id: number;
  slug: string;
  title: string;
  body: string;
  thumbnailUrl: string;
  tags: WpTagItem[];
  categories: WpCategoryItem[];
  author: WpAuthorItem;
  createdAt: string;
  updatedAt: string;
}

export const blogCategory = 'blog';
export const blogCategories = ['blog', 'news', 'usecases'];
export const blogSubCategories = ['productivity', 'integration'];

export default class Blogpost extends DomainModel {
  id: number;
  slug: string;
  title: string;
  body: string;
  thumbnailUrl: string;
  tags: WpTagItem[];
  categories: WpCategoryItem[];
  author: WpAuthorItem;
  createdAt: string;
  updatedAt: string;

  constructor(props: Props) {
    super(props);
    this._className = 'BlogPost';
    this.id = props.id;
    this.slug = props.slug;
    this.title = props.title;
    this.body = props.body;
    this.thumbnailUrl = props.thumbnailUrl;
    this.tags = props.tags;
    this.categories = props.categories;
    this.author = props.author;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }

  static permited = [];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    return super.isValid();
  }
}
